import React, { FC } from 'react';

import { Card, CardContent, Box, Divider, Grid, Link, Typography } from '@mui/material';

import PrintIcon from '@mui/icons-material/Print';

import { BackflowJobGroup } from '../../model';

interface FaxNumberDisplayProps {
  backflowJobGroup: BackflowJobGroup;
}

const FaxNumberDisplay: FC<FaxNumberDisplayProps> = (props) => {
  const { backflowJobGroup } = props;

  if (!backflowJobGroup.authority_fax_number) {
    return null;
  }

  return (
    <Card elevation={3}>
      <CardContent>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" mb={2}>
            <PrintIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" fontWeight="600">
              Fax Number
            </Typography>
          </Box>
          <Divider sx={{ mb: 1 }} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            {backflowJobGroup.authority_fax_number}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FaxNumberDisplay;
